module.exports = __webpack_public_path__ + "static/media/ninthGrade92.ea50672.aac";


//////////////////
// WEBPACK FOOTER
// ./static/music/ninthGrade92.aac
// module id = 4SaO
// module chunks = 1